'use client';

import { c as _c } from "react/compiler-runtime";
import Image from 'next/image';
import type { Ref } from 'react';
import { enhanceTwitterProfileImageUrl } from '@/lib/twitter-images';
import { cn } from '@/lib/utils';
type SizeToken = 'xs' | 'sm' | 'md' | 'lg' | 'xl';
const sizePx: Record<SizeToken, number> = {
  xs: 24,
  sm: 32,
  md: 48,
  lg: 64,
  xl: 96
};
export interface AvatarProperties {
  alt: string;
  className?: string;
  fallbackText?: string;
  onError?: () => void;
  onLoad?: () => void;
  ref?: Ref<HTMLSpanElement> | undefined;
  rounded?: 'full' | 'md' | 'none';
  size?: SizeToken | number;
  src?: string | null | undefined;
}
function pickTwitterSize(px: number): '200x200' | '400x400' {
  return px >= 56 ? '400x400' : '200x200';
}
export function Avatar(t0) {
  const $ = _c(18);
  const {
    src,
    alt,
    size: t1,
    className: t2,
    rounded: t3,
    fallbackText,
    onLoad,
    onError,
    ref
  } = t0;
  const size = t1 === undefined ? "md" : t1;
  const className = t2 === undefined ? "" : t2;
  const rounded = t3 === undefined ? "full" : t3;
  const px = typeof size === "number" ? size : sizePx[size];
  let radius = "";
  if (rounded === "full") {
    radius = "rounded-full";
  } else {
    if (rounded === "md") {
      radius = "rounded-md";
    }
  }
  const finalSource = src || null;
  const finalAlt = alt ?? "Avatar";
  let t4;
  if ($[0] !== className || $[1] !== radius) {
    t4 = cn("inline-block", radius, className);
    $[0] = className;
    $[1] = radius;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  let t5;
  if ($[3] !== px) {
    t5 = {
      width: px,
      height: px
    };
    $[3] = px;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== fallbackText || $[6] !== finalAlt || $[7] !== finalSource || $[8] !== onError || $[9] !== onLoad || $[10] !== px || $[11] !== radius) {
    t6 = finalSource && finalSource.length > 0 ? <Image src={enhanced(finalSource, px)} alt={finalAlt} width={px} height={px} className={cn("h-full w-full object-cover", radius)} loading="lazy" crossOrigin="anonymous" referrerPolicy="no-referrer" unoptimized={true} onLoad={() => onLoad?.()} onError={() => onError?.()} /> : <span className={cn("bg-muted flex items-center justify-center h-full w-full", radius)}><span className="text-sm font-semibold">{(fallbackText ?? finalAlt)?.toString().trim().charAt(0) || "?"}</span></span>;
    $[5] = fallbackText;
    $[6] = finalAlt;
    $[7] = finalSource;
    $[8] = onError;
    $[9] = onLoad;
    $[10] = px;
    $[11] = radius;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== ref || $[14] !== t4 || $[15] !== t5 || $[16] !== t6) {
    t7 = <span ref={ref} className={t4} style={t5}>{t6}</span>;
    $[13] = ref;
    $[14] = t4;
    $[15] = t5;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  return t7;
}
function enhanced(source: string, px: number) {
  return enhanceTwitterProfileImageUrl(source, pickTwitterSize(px));
}